import TourButtonWebLocation from '../enums/TourButtonWebLocation';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsTourButtonClickedParams = {
  trail_id?: number;
  web_location?: TourButtonWebLocation;
};

/**
 * User clicks the tour button CTA.
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.web_location - Web only. Whether the user clicked the tour button from the trail page or gallery.
 */
const logTrailDetailsTourButtonClicked = ({ trail_id, web_location }: logTrailDetailsTourButtonClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details tour button clicked', { 'trail id': trail_id, 'web location': web_location }, callback);
};

export default logTrailDetailsTourButtonClicked;
